// Exposing the new security keys as a constant
app.constant( Meevo.Components.Common.SecurityKeys);